import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetByGuidService } from '../../../templates/services/get-by-guid-service.template';
import { Core2Config } from '../../../utils/core2-config';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { ApiResponseModel } from '../../../models/base/api-response.model';
import { EntityContainerModel } from '../../../models/entity/entity-container.model';
import { getHttpHeader } from '../../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class EntityCustomerService extends GetByGuidService<EntityContainerModel> {

  constructor(protected readonly h: HttpClient) {
    super(Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/entity/customers', h);
  }

  public put(data: EntityContainerModel, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<EntityContainerModel>>{
    return this.http.put<ApiResponseModel<EntityContainerModel>>(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
